var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 26.6667H18.6666",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1666 18.3603V18.3337V18.3337C24.1666 16.0328 22.3008 14.167 20 14.167V14.167C17.6991 14.167 15.8333 16.0328 15.8333 18.3337V18.3337V18.3603V20.4203C15.8333 20.6903 15.6808 20.9362 15.44 21.057L15.0208 21.2662C14.4975 21.5287 14.1666 22.0637 14.1666 22.6487V22.6487C14.1666 23.502 14.8583 24.1937 15.7116 24.1937H24.2883C25.1416 24.1937 25.8333 23.502 25.8333 22.6487V22.6487C25.8333 22.0637 25.5025 21.5287 24.9791 21.267L24.56 21.0578C24.3191 20.9362 24.1666 20.6903 24.1666 20.4203V18.3603Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E6E8F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRounded);
export default __webpack_public_path__ + "static/media/Rounded.ad4e995beb62dc0e8f4d3fb58b08f14f.svg";
export { ForwardRef as ReactComponent };